declare module '@wix/blocks/types' {
  export type ComponentsStructureMap = Record<string, Record<string, unknown>>;
  export type WidgetsAPIMap = Record<
    string,
    { props: object; events: object; functions: Record<string, object> }
  >;
}
